export default {
    dhangadhi: {
        phoneNo: '+९७७-९१-५२५५०६',
        faxNo: '',
        email: 'info@dhangadhimun.gov.np',
        website: 'www.dhangadhimun.gov.np'
    }
}